// import "../../vendor/adminkit/src/js/modules/bootstrap";
// import "../../vendor/src/js/modules/sidebar";
//
// import "./theme";

import 'bootstrap/dist/js/bootstrap.bundle';

import 'select2/dist/js/select2.full';
import '@syndustry/common/vendor/confirmExit/js/confirmExit';
import '@syndustry/common/vendor/jqueryForm/js/jqueryForm';
import '@syndustry/common/vendor/sonata/js/Admin';

import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/widgets/sortable';
import 'select2';

import Syn from "@syndustry/common/js/Syn";

if(!window.Syn) {
    window.Syn = Syn;
    Syn.init();
}

// import "./modules/fullscreen";
// import "./modules/feather";

// // Global
// import "./modules/dragula";
// import "../../vendor/src/js/modules/notyf";

// // Charts
// import "./modules/apexcharts";
// import "./modules/chartjs";
//
// // Forms
// import "./modules/choices";
// import "./modules/flatpickr";
// import "./modules/inputmask";
// import "./modules/quill";
//
// // Maps
// import "./modules/vector-maps";